import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import { Suspend, SuspendListResponse, SuspendTypeResponse, SystemSuspendListResponse } from '../models/suspend';
import { CompanyShareholder } from 'core/models/shareholder';

export const onGetCompanySuspendRequestList = async (page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<SuspendListResponse>>('dashboard/actions/suspend', {
			params: { page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetCompanySuspendRequestById = async (id: string) => {
	try {
		const response = await axios.get<JsonResponse<Suspend>>(`dashboard/actions/suspend/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetSystemSuspendRequestList = async (page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<SystemSuspendListResponse>>('dashboard/actions/system-suspend', {
			params: { page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetSystemSuspendRequestById = async (id: string) => {
	try {
		const response = await axios.get<JsonResponse<Suspend>>(`dashboard/actions/system-suspend/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetSuspendRequestReasons = async () => {
	try {
		const response = await axios.get<JsonResponse<SuspendTypeResponse>>(`dashboard/actions/suspend/types`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSubmitSuspendRequest = async (data: FormData) => {
	try {
		const response = await axios.post<JsonResponse<Suspend>>(`dashboard/actions/suspend`, data);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCheckCompanyShareholder = async (nationalId: string) => {
	try {
		const response = await axios.get<JsonResponse<{ company_shareholder: CompanyShareholder; has_pending_transactions: boolean }>>(
			`dashboard/actions/suspend/check-company-shareholder?national_id=${nationalId}`,
		);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCancelCompanySuspendRequest = async (suspendId: number, values: FormData) => {
	try {
		const response = await axios.post(`dashboard/actions/suspend/${suspendId}/cancel`, values);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};


export const onCancelSystemSuspendRequest = async (suspendId: number, values: FormData) => {
	try {
		const response = await axios.post(`dashboard/actions/system-suspend/${suspendId}/cancel`, values);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSendSuspendOtp = async () => {
	try {
		const response = await axios.post(`dashboard/actions/suspend/send-otp`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCheckGeneralSuspend = async () => {
	try {
		const response = await axios.get<JsonResponse<{ has_active_general_suspend_action: number }>>('dashboard/actions/suspend/has-active-general-suspend');
		return response.data.data.has_active_general_suspend_action;
	} catch (error) {
		throw error;
	}
};